// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uc-0";
export var checkoutRateBadgeLink = "_uc-1";